import * as tslib_1 from "tslib";
import { getOpenQuickViewUrl, translationPath, DEFAULT_COLLECTION_ID, TRACK_EVENT_COLLECTION, GALLERY_FEDOPS_APP_NAME, } from '../constants';
import { create } from '@wix/fedops-logger';
import { getTranslations, isWorker } from '@wix/wixstores-client-core/dist/es/src/viewer-script/utils';
import { FiltersStore } from './filtersStore';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import { FilterConfigsService } from '../services/filterConfigsService';
import { PageMap, APP_DEFINITION_ID } from '@wix/wixstores-client-core/dist/es/src/constants';
import { getStyleParamsWithDefaultsFunc } from '../getStyleParamsWithDefaultsFunc';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import UrlParser from '@wix/wixstores-client-core/dist/es/src/url-parser';
var GalleryStore = /** @class */ (function () {
    function GalleryStore(styleParams, config, updateComponent, siteStore, productsService, compId, type, reportError) {
        this.styleParams = styleParams;
        this.config = config;
        this.updateComponent = updateComponent;
        this.siteStore = siteStore;
        this.productsService = productsService;
        this.compId = compId;
        this.type = type;
        this.reportError = reportError;
        this.fedopsLogger = create(GALLERY_FEDOPS_APP_NAME);
        this.isFedopsReport = true;
        /* istanbul ignore next: can test this once this is solved: https://jira.wixpress.com/browse/EE-16513*/
        if (this.config.publicData.COMPONENT === null || this.config.publicData.COMPONENT === undefined) {
            this.config.publicData.COMPONENT = {};
        }
        var fedopsAppName = "" + GALLERY_FEDOPS_APP_NAME + (isWorker() ? '-ooi' : '');
        if (isWorker()) {
            if (this.siteStore.experiments.enabled('specs.stores.NewFedopsIntegration')) {
                var fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
                this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
                    appId: APP_DEFINITION_ID,
                    widgetId: this.type,
                });
            }
            else {
                this.fedopsLogger = create(fedopsAppName, {
                    isWidgetLogger: true,
                    isServerSide: this.siteStore.isSSR(),
                    appId: APP_DEFINITION_ID,
                    metasiteId: this.siteStore.msid,
                    widgetId: this.type,
                });
            }
            this.fedopsLogger.appLoadStarted();
        }
        else {
            this.fedopsLogger = create(fedopsAppName);
        }
    }
    GalleryStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, translations, data, url, products, filterModels;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.siteStore.isSSR()) {
                            this.fedopsLogger.interactionStarted('page-ready');
                        }
                        return [4 /*yield*/, Promise.all([
                                getTranslations(translationPath(this.siteStore.baseUrls.galleryBaseUrl, this.siteStore.locale)),
                                this.productsService.getInitialData(this.config.externalId, this.compId),
                                this.siteStore.getSectionUrl(PageMap.PRODUCT),
                            ]).catch(this.reportError)];
                    case 1:
                        _a = _b.sent(), translations = _a[0], data = _a[1], url = _a[2].url;
                        products = data.catalog.category.productsWithMetaData.list;
                        this.translations = translations;
                        this.productPageSectionUrl = url;
                        this.mainCollectionId = this.productsService.getMainCollectionId();
                        this.productIdToProductPageUrlMap = this.generateProductIdToProductPageUrlMap(products);
                        this.multilingualService = new MultilingualService(this.config.publicData.COMPONENT, data.appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        this.filterConfigsService = new FilterConfigsService(data.appSettings.widgetSettings.FILTERS, this.config.publicData.COMPONENT.FILTERS && this.config.publicData.COMPONENT.FILTERS.data, this.styleParams.booleans, this.multilingualService, translations);
                        filterModels = [];
                        if (!this.shouldShowFilters()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchFilters()];
                    case 2:
                        filterModels = _b.sent();
                        _b.label = 3;
                    case 3:
                        this.updateComponent(this.getPropsToInject(products, filterModels));
                        if (this.siteStore.isSSR()) {
                            this.fedopsLogger.appLoaded();
                        }
                        else {
                            this.fedopsLogger.interactionEnded('page-ready');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.onAppLoaded = function () {
        /* istanbul ignore next: hard to test it */
        if (this.isFedopsReport) {
            this.fedopsLogger.appLoaded();
            this.isFedopsReport = false;
        }
    };
    GalleryStore.prototype.getPropsToInject = function (products, filterModels) {
        return {
            clearFilters: this.clearFilters.bind(this),
            cssBaseUrl: this.siteStore.baseUrls.galleryBaseUrl,
            filterModels: filterModels,
            filterProducts: this.filterProducts.bind(this),
            handleProductItemClick: this.handleProductItemClick.bind(this),
            hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
            isFirstPage: true,
            isInteractive: this.siteStore.isInteractive(),
            isLiveSiteMode: this.siteStore.isSiteMode(),
            isLoaded: true,
            isMobile: this.siteStore.isMobile(),
            isRTL: this.siteStore.isRTL(),
            loadMoreProducts: this.loadMoreProducts.bind(this),
            mainCollectionId: this.mainCollectionId,
            onAppLoaded: this.onAppLoaded.bind(this),
            openQuickView: this.openQuickView.bind(this),
            productIdToProductPageUrlMap: this.productIdToProductPageUrlMap,
            products: products,
            ravenUserContextOverrides: { id: this.siteStore.storeId },
            setProductsPerPage: this.setProductsPerPage.bind(this),
            shouldShowClearFilters: false,
            hasSelectedFilters: false,
            shouldShowSort: this.shouldShowSort(),
            sortProducts: this.sortProducts.bind(this),
            textsMap: this.getTextsMap(),
            totalProducts: this.productsService.totalCount,
            experiments: {
                isMobileFiltersEnabled: this.siteStore.experiments.enabled('specs.stores.MobileFilters'),
                isClientGalleryUseAutoUpscaleEnabled: this.siteStore.experiments.enabled('specs.stores.ClientGalleryUseAutoUpscale'),
            },
            shouldShowMobileFiltersModal: false,
            toggleFiltersModalVisibility: this.toggleFiltersModalVisibility.bind(this),
            filterProductsOnMobile: this.filterProductsOnMobile.bind(this),
            loading: false,
        };
    };
    GalleryStore.prototype.getTextsMap = function () {
        return tslib_1.__assign({}, this.translations, { mobileFiltersButtonText: this.translations['gallery.mobile.filters.title.button'], sliderGalleryNoProductsMessageText: this.translations.NO_PRODUCTS_MESSAGE_MINI_GALLERY_MAIN, quickViewButtonText: this.translations.QUICK_VIEW, filtersTitleText: this.multilingualService.get('FILTERS_MAIN_TITLE') || this.translations['filter.MAIN_TITLE'], loadMoreButtonText: this.multilingualService.get('LOAD_MORE_BUTTON') || this.translations.LOAD_MORE_BUTTON, clearFiltersButtonText: this.translations['filter.CLEAN_ALL'], allCollectionsFilterButtonText: this.translations['filter.CATEGORY_ALL'], noProductsMessageText: this.translations.NO_PRODUCTS_MESSAGE_MAIN, noProductsFilteredMessageText: this.translations.NO_PRODUCTS_FILTERED_MESSAGE_MAIN, sortTitleText: this.multilingualService.get('SORTING_MAIN_TITLE') || this.translations.SORT_BY, sortOptionNewestText: this.translations['sort.NEWEST'], sortOptionLowPriceText: this.translations['sort.PRICE_LOW'], sortOptionHighPriceText: this.translations['sort.PRICE_HIGH'], sortOptionNameAZText: this.translations['sort.NAME_AZ'], sortOptionNameZAText: this.translations['sort.NAME_ZA'], productPriceBeforeDiscountSR: this.translations['sr.PRODUCT_PRICE_BEFORE_DISCOUNT'], productPriceAfterDiscountSR: this.translations['sr.PRODUCT_PRICE_AFTER_DISCOUNT'], productPriceWhenThereIsNoDiscountSR: this.translations['sr.PRODUCT_PRICE_WHEN_THERE_IS_NO_DISCOUNT'], productOutOfStockText: this.translations.OUT_OF_STOCK_LABEL, galleryRegionSR: this.translations['sr.region.GALLERY'], filtersSubmitButtonText: this.translations['gallery.mobile.filters.buttonApply'] });
    };
    GalleryStore.prototype.generateProductIdToProductPageUrlMap = function (products) {
        return products.reduce(this._productsToUrlsReducer.bind(this), {});
    };
    GalleryStore.prototype._productsToUrlsReducer = function (acc, product) {
        acc[product.id] = new UrlParser(this.productPageSectionUrl + "/" + product.urlPart).generate({}, {});
        return acc;
    };
    GalleryStore.prototype.filterProducts = function (filterId, selectionValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.isMobile()) return [3 /*break*/, 1];
                        this.filtersStore.updateSelectedFilterOption(filterId, selectionValue);
                        this.updateComponent({ filterModels: this.filtersStore.getFilterModels() });
                        return [3 /*break*/, 3];
                    case 1:
                        this.filtersStore.updateActiveFilterOption(filterId, selectionValue);
                        return [4 /*yield*/, this.updateComponentWithFilteredProducts(this.filtersStore.shouldShowClearFilters())];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.filterProductsOnMobile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filtersStore.updateActiveFiltersWithSelected();
                        this.updateComponent({ loading: true });
                        return [4 /*yield*/, this.updateComponentWithFilteredProducts(this.filtersStore.shouldShowClearFilters())];
                    case 1:
                        _a.sent();
                        this.updateComponent({ loading: false, shouldShowMobileFiltersModal: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.clearFilters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filtersStore.resetFilters();
                        return [4 /*yield*/, this.updateComponentWithFilteredProducts(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.toggleFiltersModalVisibility = function (value) {
        this.updateComponent({
            shouldShowMobileFiltersModal: value,
        });
    };
    GalleryStore.prototype.updateComponentWithFilteredProducts = function (shouldShowClearFilters) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filtersDTO, newProducts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filtersDTO = this.filtersStore.getFilterDTOs();
                        return [4 /*yield*/, this.productsService.filterProducts(filtersDTO, this.filtersStore.getCollectionIdsFilterDTO())];
                    case 1:
                        newProducts = _a.sent();
                        this.updateComponent({
                            products: newProducts,
                            hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
                            isFirstPage: false,
                            productIdToProductPageUrlMap: this.generateProductIdToProductPageUrlMap(newProducts),
                            filterModels: this.filtersStore.getFilterModels(),
                            shouldShowClearFilters: shouldShowClearFilters,
                            hasSelectedFilters: shouldShowClearFilters,
                            shouldShowSort: this.shouldShowSort(),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.setProductsPerPage = function (productPerPage) {
        this.productsService.setProductsPerPage(productPerPage);
    };
    GalleryStore.prototype.loadMoreProducts = function (visibleProducts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionId, newProducts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fedopsLogger.interactionStarted('load-more');
                        collectionId = this.productsService.getMainCollectionId();
                        //tslint:disable-next-line:no-floating-promises
                        this.siteStore.biLogger.clickLoadMoreInGallerySf(collectionId === DEFAULT_COLLECTION_ID ? {} : { categoryId: collectionId });
                        return [4 /*yield*/, this.productsService.loadMoreProducts(visibleProducts)];
                    case 1:
                        newProducts = _a.sent();
                        if (newProducts === null) {
                            this.updateComponent({
                                hasMoreProductsToLoad: false,
                            });
                            return [2 /*return*/];
                        }
                        this.updateComponent({
                            products: newProducts,
                            focusedProductIndex: visibleProducts,
                            isFirstPage: false,
                            productIdToProductPageUrlMap: this.generateProductIdToProductPageUrlMap(newProducts),
                            hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
                        });
                        this.fedopsLogger.interactionEnded('load-more');
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.sortProducts = function (sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newProducts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //tslint:disable-next-line:no-floating-promises
                        this.siteStore.biLogger.sortGallerySf({ sortDir: sorting.direction });
                        return [4 /*yield*/, this.productsService.sortProducts(sorting)];
                    case 1:
                        newProducts = _a.sent();
                        this.updateComponent({
                            products: newProducts,
                            productIdToProductPageUrlMap: this.generateProductIdToProductPageUrlMap(newProducts),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GalleryStore.prototype.shouldShowSort = function () {
        var _a = this.styleParams.booleans, galleryShowSort = _a.galleryShowSort, gallerySortNewest = _a.gallerySortNewest, gallerySortPriceAsc = _a.gallerySortPriceAsc, gallerySortPriceDes = _a.gallerySortPriceDes, gallerySortNameAsc = _a.gallerySortNameAsc, gallerySortNameDes = _a.gallerySortNameDes;
        return (galleryShowSort &&
            (gallerySortNewest || gallerySortPriceAsc || gallerySortPriceDes || gallerySortNameAsc || gallerySortNameDes) &&
            this.productsService.products.length > 0);
    };
    GalleryStore.prototype.openQuickView = function (_a) {
        var productId = _a.productId, index = _a.index;
        var product = this.productsService.getProduct(productId);
        this.siteStore.biLogger.clickedOnProductQuickViewSf({
            productId: productId,
            hasRibbon: !!product.ribbon,
            hasOptions: !!product.options.length,
            index: index,
        }); // tslint:disable-line no-floating-promises
        this.siteStore.windowApis.openModal(getOpenQuickViewUrl(productId, this.config.externalId, this.siteStore.instance), {
            width: 940,
            height: 660,
        }, this.compId); // tslint:disable-line no-floating-promises
        this.sendClickTrackEvent(product, index);
    };
    GalleryStore.prototype.sendClickTrackEvent = function (product, index) {
        this.siteStore.windowApis.trackEvent('ClickProduct', {
            appDefId: APP_DEFINITION_ID,
            id: product.id,
            origin: 'Stores',
            name: product.name,
            list: 'Grid Gallery',
            category: TRACK_EVENT_COLLECTION,
            position: index,
            price: product.comparePrice || product.price,
            currency: this.siteStore.currency,
        });
    };
    GalleryStore.prototype.handleProductItemClick = function (_a) {
        var _b = _a.biData, productId = _b.productId, index = _b.index;
        var product = this.productsService.getProduct(productId);
        this.productsService.storeNavigation(this.siteStore.siteApis.currentPage.id);
        this.siteStore.biLogger.clickOnProductBoxSf({
            productId: productId,
            hasRibbon: !!product.ribbon,
            hasOptions: !!product.options.length,
            index: index,
            productType: product.productType,
        }); // tslint:disable-line no-floating-promises
        this.sendClickTrackEvent(product, index);
        this.siteStore.navigate({
            sectionId: PageMap.PRODUCT,
            state: product.urlPart,
            queryParams: undefined,
        }); // tslint:disable-line no-floating-promises
    };
    GalleryStore.prototype.fetchFilters = function () {
        this.filtersStore = new FiltersStore(this.siteStore, this.mainCollectionId, this.filterConfigsService);
        return this.filtersStore.fetchFilters();
    };
    GalleryStore.prototype.shouldShowFilters = function () {
        return this.styleParams.booleans.galleryShowFilters && this.filterConfigsService.shouldShowFilters();
    };
    GalleryStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.config.publicData = newPublicData;
        this.styleParams = getStyleParamsWithDefaults(newStyleParams, function () {
            return getStyleParamsWithDefaultsFunc({
                style: { styleParams: newStyleParams },
                dimensions: undefined,
            });
        });
        if (!this.shouldShowFilters()) {
            this.updateComponent({ filterModels: [] });
        }
        this.updateComponent({
            textsMap: this.getTextsMap(),
            shouldShowSort: this.shouldShowSort(),
        });
    };
    return GalleryStore;
}());
export { GalleryStore };
//# sourceMappingURL=galleryStore.js.map